import angular from "angular";
import "../../../services/cart";
import '../../../directives/register-form';

angular.module("folkeuni").component("keyAccount", {
  bindings: {
    cart: "=",
    state: "<",
  },
  controller: function (
    $location,
    $window,
    Cart,
    $rootScope,
    $scope,
    $element
  ) {
    var $ctrl = this;

    $ctrl.$onInit = function () {
      if (typeof $rootScope !== "undefined") {
        $rootScope.$on("cart.update", function (evt, cart) {
          $ctrl.cart = cart;
        });
      }
    };

    $scope.keyAccountForms = {};
    $scope.registerForm = function (index, form) {
      $scope.keyAccountForms[index] = form;
    };

    $scope.$on("checkout:showAllErrors", function () {
      angular.forEach($scope.keyAccountForms, function (form) {
        if (form) {
          angular.forEach(form, function (field) {
            if (field && field.$setTouched) field.$setTouched();
            if (field && field.$validate) field.$validate();
          });
        }
      });
    });
  },

  templateUrl: "/shop-dist/templates/key-account.html?c=" + window.cacheBurst,
  transclude: true,
});
